export let events;
(function (events) {
  events["interaction"] = "interaction";
  events["usage"] = "usage";
  events["view"] = "view";
})(events || (events = {}));
export let commerceEvents;
(function (commerceEvents) {
  commerceEvents["interaction"] = "interaction";
})(commerceEvents || (commerceEvents = {}));